<div class="qb-d-block">
  <div class="qb-viewtype-container">
    <div class="qb-select-type">
      <!-- <mat-select
        placeholder="Select"
        [(ngModel)]="viewType"
        (selectionChange)="onViewTypeChange($event)"
      >
        <mat-option
          *ngFor="let val of typeOfView"
          [value]="val.type"
          selected
          >{{ val.displayName }}</mat-option
        >
      </mat-select> -->
      <mat-radio-group
        aria-labelledby="example-radio-group-label"
        class="qb-pn-radio-group"
        [(ngModel)]="viewType"
        (change)="onViewTypeChange($event)"
      >
        <mat-radio-button
          color="primary"
          *ngFor="let val of typeOfView"
          [value]="val.type"
        >
          {{ val.displayName }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div
    class="qb-mobile-screen-wrapper-andriod"
    id="pn-mobile-screen-wrapper"
    *ngIf="viewType === 'ANDRIOD'"
  >
    <div class="qb-notification-wrapper-andriod" id="pn-wrapper">
      <div
        class="qb-notification-div-andriod-expand"
        id="pn-div"
        (click)="expandView()"
      >
        <div class="qb-icon-area-andriod">
          <div class="qb-icon-container-andriod">
            <span class="qb-andriod-icon"></span>
          </div>
        </div>
        <header class="qb-header-container" id="andriod-header-container">
          <div class="qb-header-wrapper">
            <h1 class="qb-header-message-collapse" *ngIf="isCollapsed">
              {{ header }}
            </h1>
            <span class="qb-header-text-value"> {{ storeName }} . now </span>
          </div>
          <div class="qb-body-message" *ngIf="isCollapsed">
            {{ body }}
          </div>
        </header>
        <div class="qb-chevron-container">
          <span class="qb-chevron-icon"> </span>
        </div>
      </div>
    </div>
  </div>
  <div class="qb-mobile-screen-wrapper-ios" *ngIf="viewType === 'IOS'">
    <div
      class="qb-notification-wrapper-apple"
      [ngClass]="{
        'qb-notification-wrapper-apple-img-present': uploadedImg,
        'qb-notification-wrapper-apple': !uploadedImg
      }"
      id="pn-wrapper-ios"
    >
      <div class="qb-notification-ios">
        <div class="qb-content-ios" (click)="expandView()">
          <div class="qb-appicon-container-ios">
            <div class="qb-appicon-body">
              <div class="qb-app-icon"></div>
            </div>
          </div>
          <div class="qb-text-ios">
            <h2 class="qb-ios-header-text">
              {{ header }}
            </h2>
            <div class="qb-text-body-ios">
              <p class="qb-ios-p">
                {{ body }}
              </p>
            </div>
          </div>
          <div class="qb-right-content-ios">
            <div class="qb-ios-now-content">now</div>
            <img
              [src]="uploadedImg"
              alt=""
              class="qb-img-ios-collapsed"
              *ngIf="isCollapsed"
            />
          </div>
        </div>
        <img
          [src]="uploadedImg"
          alt=""
          class="qb-img-expand-ios"
          *ngIf="!isCollapsed"
        />
      </div>
    </div>
  </div>
</div>
